import {
  PaccApplyResultListDto,
  PhsApplyResultsRs,
  PstApplyResultListDto,
} from '@domain/rs/phs/apply/PhsApplyResultsRs';
import { PHSAnalysisType } from '@domain/constant/phsAnalysisType';

export class PaccApplyResultListVO {
  applySn: number;
  createdDateTime: string;
  endDateTime: string;
  analysisType: PHSAnalysisType;

  constructor(paccApplyResultListDto: PaccApplyResultListDto) {
    this.applySn = paccApplyResultListDto.applySn;
    this.createdDateTime = paccApplyResultListDto.createdDateTime;
    this.endDateTime = paccApplyResultListDto.endDateTime;
    this.analysisType = paccApplyResultListDto.analysisType;
  }
}

export class PstApplyResultListVO {
  applySn: number;
  createdDateTime: string;
  endDateTime: string;
  analysisType: PHSAnalysisType;

  constructor(pstApplyResultListDto: PstApplyResultListDto) {
    this.applySn = pstApplyResultListDto.applySn;
    this.createdDateTime = pstApplyResultListDto.createdDateTime;
    this.endDateTime = pstApplyResultListDto.endDateTime;
    this.analysisType = pstApplyResultListDto.analysisType;
  }
}

export class PhsApplyResultsVO {
  paccResults: PaccApplyResultListDto[]; // 개발자 역량검사 결과 목록
  pstResults: PstApplyResultListDto[]; // 개능검 결과 목록

  constructor(phsApplyResultsRs: PhsApplyResultsRs) {
    this.paccResults = phsApplyResultsRs.paccResults.map((result) => new PaccApplyResultListVO(result));
    this.pstResults = phsApplyResultsRs.pstResults.map((result) => new PstApplyResultListVO(result));
  }
}
